<template>
<div>
  <div>
  <transition mode="out-in">
    <section class="box_3grid">
    <div class="card-home-promocao">
    <div class="data-horario">
      <div>
        <i class="far fa-clock icone-relogio"></i>
        <span>PROMOÇÕES</span>
      </div>
    </div>
    <div class="outer-div">
      <a @click="comprar(promocao)">
        <div style="'background': 'https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Fpromo_site.webp?alt=media&token=48c2971a-6c9d-40bc-b9f4-f943ddff4adc'), 'background-size': 'cover'" class="inner-div"></div>
      </a>
    </div>
    <div>
      <h3 class="titulo">PROMOÇÕES EXCLUSIVAS NO NOSSO SITE</h3>
      <p class="preco">Compra antecipada com datas e horários pré-definidos</p>
      <div class="expira">
      </div>
    </div>
  </div>
  </section>
  </transition>
  </div>
  </div>
</template>

<script>
import { db, Timestamp } from '@/firebase.js'
import _ from 'lodash'

export default {
  name: 'HomeGrid3',
  components: {
    db
  },
  data: function () {
    return {
      slides: 3,
      promocoes: [],
      valorQuantidade: 0
    }
  },
  created () {
    this.getPromocoes()
  },
  methods: {
    dataContador (promocaoDataFim) {
      return Math.trunc((promocaoDataFim.toDate()) - Date.now())
    },
    finalCountdown (produtoId) {
      this.promocoes = this.promocoes.filter((obj) => {
        return obj.ProdutoId !== produtoId
      })
    },
    getPromocoes () {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: '#F85E28',
        loader: 'spinner',
        width: 100,
        height: 100,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      })
      db.collection('Promocoes').where('Ativo', '==', true).onSnapshot((querySnapshot) => {
        querySnapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            if (change.doc.data().DataInicio < Timestamp.now()) {
              if (change.doc.data().DataFim > Timestamp.now()) {
                this.valorQuantidade = 0
                Object.keys(change.doc.data().QtdUnidades).forEach((key) => {
                  this.valorQuantidade = (this.valorQuantidade + change.doc.data().QtdUnidades[key]) - change.doc.data().QtdUnidadesReserva[key]
                })
                if (this.valorQuantidade > 0) {
                  var documento = change.doc.data()
                  documento.id = change.doc.id
                  this.promocoes.push(documento)
                  this.promocoes = _.sortBy(this.promocoes, o => [o.DataOk, o.Horario, o.ProdutoTitulo])
                }
              }
            }
          } else if (change.type === 'modified') {
            this.promocoes = this.promocoes.filter((obj) => {
              return obj.id !== change.doc.id
            })
            if (change.doc.data().DataInicio < Timestamp.now()) {
              if (change.doc.data().DataFim > Timestamp.now()) {
                this.valorQuantidade = 0
                Object.keys(change.doc.data().QtdUnidades).forEach((key) => {
                  this.valorQuantidade = (this.valorQuantidade + change.doc.data().QtdUnidades[key]) - change.doc.data().QtdUnidadesReserva[key]
                })
                if (this.valorQuantidade > 0) {
                  var documento2 = change.doc.data()
                  documento2.id = change.doc.id
                  this.promocoes.push(documento2)
                  this.promocoes = _.sortBy(this.promocoes, o => [o.DataOk, o.Horario, o.ProdutoTitulo])
                }
              }
            }
          } else if (change.type === 'removed') {
            this.promocoes = this.promocoes.filter((obj) => {
              return obj.id !== change.doc.id
            })
          }
        })
      })
      loader.hide()
    },
    comprar (documento) {
      localStorage.setItem('promoProps', JSON.stringify(documento))
      this.$router.push({name: 'Comprar', params: {id: documento.id}})
    }
  }
}

</script>

<style scoped>
/* CARD COM 3 FOTOS NA LINHA */

.box_3grid {
  grid-area: box_3grid;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: center;
  gap: 50px;
  margin: 0 0 20px 0;
}

@media (max-width: 1170px) {
  .box_3grid {
    grid-template-columns: 1fr 1fr;
    justify-content: space-around;
    margin: 40px 60px;
  }
}

@media (max-width: 860px) {
  .box_3grid {
    grid-template-columns: 1fr;
    justify-content: center;
    margin: 20px 0 40px 0;
  }
}

.card-home-promocao {
  background: #fff;
  width: 356px;
  height: 425px;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 20px;
  margin: 40px auto 0 auto;
  transition: all 0.3s;
  justify-self: center;
}

@media (max-width: 1170px) {
  .card-home-promocao  {
    justify-self: center;
    margin: 10px auto 0 auto;
    width: 95%;
  }
}

.card-home-promocao:hover {
  transform: scale(1.1);
  position: relative;
  z-index: 1;
}

@media (max-width: 760px) {
.card-home-promocao:hover {
  transform: scale(1);
}
}

.outer-div {
  width: 98%;
  height: 230px;
  overflow: hidden;
  margin: 8px auto 12px auto;
}

.inner-div {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  transition: all 0.7s ease;
}

.inner-div:hover {
  transform: scale(1.1);
}

.icone_svg {
  width: 36px;
  height: 36px;
}

.titulo, .data-horario {
  margin: 5px 0;
}

.preco {
  color: #F85E28;
  font-weight: 600;
  font-size: 1.2em;
}

.btn {
  margin: 25px auto 0 auto;
}

.expira {
  display: flex;
  color: #ccc;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}

.expira-hora {
  margin: 0 0 0 8px;
  font-size: 0.8em;
}

.icone-ampulheta {
  width: 13px;
  height: 13px;
  align-self: center;
}

.icone-relogio {
  margin: 0 0 0 10px;
}

.data-horario {
  font-weight: 600;
  color: #F85E28;
  font-size: 1rem;
  letter-spacing: -0.5px;
  display: flex;
  justify-content: center;
}

.data-horario span {
  padding: 0 0 0 2px;
}

@media (max-width: 760px) {
  .data-horario {
    font-size: 0.9rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HomeGridIndex.vue